import { DownOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { useState, useCallback } from "react";
import { __ } from "../../../utils";
import { ESubscriptionStatus } from "@devowl-wp/api-real-commerce";
import { ChangePaymentDetailsModal, ChangePlanModal } from ".";
import { useSubscriptionCancel } from "../../../hooks/useSubscriptionCancel";
const ACCOUNT_SUBSCRIPTION_ACTIONS_UPGRADE_OR_DOWNGRADE = "upgrade-or-downgrade";
const AccountSubscriptionActions = observer(_ref => {
  let {
    record
  } = _ref;
  const {
    data: {
      status,
      paymentInformation
    },
    canBeModified,
    isOneTime
  } = record;
  const [isChangePlanModalVisible, setIsChangePlanModalVisible] = useState(false);
  const [isChangePaymentDetailsModalVisible, setIsChangePaymentDetailsModalVisible] = useState(false);
  const handleToggleChangePlanModalVisible = useCallback(() => {
    setIsChangePlanModalVisible(!isChangePlanModalVisible);
  }, [isChangePlanModalVisible]);
  const handleToggleChangePaymentDetailsModalVisible = useCallback(() => {
    setIsChangePaymentDetailsModalVisible(!isChangePaymentDetailsModalVisible);
  }, [isChangePaymentDetailsModalVisible]);
  const handleCancelClick = useSubscriptionCancel(record);
  const disabled = status !== ESubscriptionStatus.Active || !canBeModified;
  const paymentMethodChangedDisabled = !paymentInformation;

  // Allow to listen to events so parent elements can query selector for this div and dispatch events
  const ref = useRef();
  useEffect(() => {
    const {
      current
    } = ref;
    if (current) {
      const listenerChangePlanModalVisible = () => {
        setIsChangePlanModalVisible(true);
      };
      current.addEventListener(ACCOUNT_SUBSCRIPTION_ACTIONS_UPGRADE_OR_DOWNGRADE, listenerChangePlanModalVisible);
      return () => {
        current.removeEventListener(ACCOUNT_SUBSCRIPTION_ACTIONS_UPGRADE_OR_DOWNGRADE, listenerChangePlanModalVisible);
      };
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }, [ref.current]);
  return isOneTime ? /*#__PURE__*/React.createElement(React.Fragment, null, "-") : /*#__PURE__*/React.createElement("div", {
    className: "real-commerce-subscription-actions",
    ref: ref
  }, /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: [{
        key: "upgrade",
        disabled: disabled || (paymentInformation === null || paymentInformation === void 0 ? void 0 : paymentInformation.status) === "past_due",
        onClick: handleToggleChangePlanModalVisible,
        label: __("Upgrade or downgrade")
      }, {
        key: "change",
        disabled: disabled || paymentMethodChangedDisabled,
        onClick: handleToggleChangePaymentDetailsModalVisible,
        label: __("Change payment details")
      }, !disabled && {
        key: "cancel",
        danger: canBeModified,
        onClick: handleCancelClick,
        label: __("Cancellation")
      }].filter(Boolean)
    },
    placement: "bottomRight",
    trigger: ["click"]
  }, /*#__PURE__*/React.createElement("a", null, __("Actions"), " ", /*#__PURE__*/React.createElement(DownOutlined, null))), /*#__PURE__*/React.createElement(ChangePaymentDetailsModal, {
    record: record,
    visible: isChangePaymentDetailsModalVisible,
    onClose: handleToggleChangePaymentDetailsModalVisible
  }), /*#__PURE__*/React.createElement(ChangePlanModal, {
    record: record,
    visible: isChangePlanModalVisible,
    onClose: handleToggleChangePlanModalVisible
  }));
});
export { AccountSubscriptionActions, ACCOUNT_SUBSCRIPTION_ACTIONS_UPGRADE_OR_DOWNGRADE };